const tableHeader = [
    { prop: 'num', label: '序号' },
    { prop: 'warehouse', label: '仓库名称' },
    { prop: 'quoteItem', label: '报价项目' },
    { prop: 'priceUnit', label: '单价单位' },
    { prop: 'flowRate', label: '流量、面积' },
    { prop: 'remark', label: '备注' },
    { prop: 'formula', label: '关联公式' },
    { prop: 'volume', label: '预计业务量（元）' },
    { prop: 'totalPrice', label: '总物流费用（元）' },
    { prop: 'price', label: '单价（元）' }
];
export default tableHeader;